import React, { useEffect, useCallback } from 'react';
import { Menu } from '@material-ui/core';
import { MyMenuItem } from '../../../styling/Styles';
import { getAllComponents } from '../Events/CreateRulesPerPage';

const ApplyStylingOptions = (props) => {
    
    const{
        anchorEl,
        setAnchorEl,
        projectNamesPages,
        selectedProject,
        selectedPage,
        editor,
        savedPagesPerProject,
        setSavedPagesPerProject
    } = props;
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const getCss = (page) => {

        const targetPageStyles = JSON.parse(localStorage.getItem('data'))[selectedProject].pages.filter( (pageComp) =>  pageComp.name === page).map(pageComp => pageComp)[0].styles;
        const filterElementStyleAppliedSelectors = [];
        const projectName = JSON.parse(localStorage.getItem('data'))[selectedProject].name;
        const pageName =  JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].name;
        targetPageStyles.forEach( selector => {
            selector.selectors.forEach( (insideClass) => {
                if(typeof(insideClass) === 'string' && insideClass.startsWith('classRule') === true && insideClass.endsWith(`${projectName}-${page}`) && selector.selectors.length > 1){
                    filterElementStyleAppliedSelectors.push(selector); 
                }
            })
        })

        const allComponents = getAllComponents(editor.DomComponents.getWrapper());
        const newCreatedSelectors = [];
        allComponents.forEach( comp => {
            const compsClasses = [];
            comp.attributes.classes.models.forEach( (classEl) => {
                compsClasses.push(classEl.attributes.name);
            })
            
            let stringifyClassesEl = '';

            filterElementStyleAppliedSelectors.forEach( selector => {
                const stringifySelector = JSON.stringify(selector.selectors.filter( classRule => classRule.startsWith('classRule')===false).map(classRule => classRule).sort());
                stringifyClassesEl = JSON.stringify(compsClasses.filter( classRule => classRule.startsWith('classRule')===false).map(classRule => classRule).sort());
                if(stringifyClassesEl === stringifySelector){
                    const updatedSelector = {'selectors': [], 'style': selector.style};
                    const compClassRule = `classRule-${comp.ccid}-${projectName}-${pageName}`;
                    selector.selectors.forEach( sel => {
                        if(sel.startsWith('classRule') === true){
                            updatedSelector.selectors.push(compClassRule);
                        }
                        else{
                            updatedSelector.selectors.push(sel);
                        }
                    })
                    newCreatedSelectors.push(updatedSelector);
                }
            })

        })

        const currentStyles = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].styles;
        localStorage.setItem('gjs-styles', JSON.stringify([...currentStyles,...newCreatedSelectors]));

        editor.load((res) => {
            const keys = ['gjs-styles'];
            for (let i = 0, len = keys.length; i < len; i += 1) {
              const v = localStorage.getItem(keys[i]);
              if (v) res[keys[i]] = v;
            }
            return res;
          });

        editor.refresh();

        if(newCreatedSelectors.length > 0){
            const tempSavedPagesPerProject = [...savedPagesPerProject];
            tempSavedPagesPerProject[selectedProject][selectedPage] = false;
            setSavedPagesPerProject(tempSavedPagesPerProject);
        }

        setAnchorEl(null);
    }

    return(
        <Menu
            id="simple-menu1"
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            {projectNamesPages !== undefined && projectNamesPages[selectedProject]!==undefined &&
                projectNamesPages[selectedProject].filter((page,indexPage) => indexPage !== selectedPage).map( (page) => 
                    (
                        <MyMenuItem id={`applyStylingFrom${page}`} key={`applyStylingFrom${page}`} onClick={() => getCss(page)}>
                            {page}
                        </MyMenuItem> 
                    )
                )
            }
        </Menu>
    )
}

const PanelBasicActions = (props) => {

    const {
        editor,
        selectedPage,
        selectedProject,
        anchorApplyStylingEl,
        setAnchorApplyStylingEl,
        projectNamesPages,
        savedPagesPerProject,
        setSavedPagesPerProject
    } = props;

    const [escapeClicked, setEscapeClicked] = React.useState(false);

    const exitHandler = useCallback(() => {
        if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        setEscapeClicked(true);
        }
    }, []);

    useEffect(() => {
        document.addEventListener('fullscreenchange', exitHandler, false,{passive: true});
        document.addEventListener('mozfullscreenchange', exitHandler, false,{passive: true});
        document.addEventListener('MSFullscreenChange', exitHandler, false,{passive: true});
        document.addEventListener('webkitfullscreenchange', exitHandler, false,{passive: true});
    }, []);

    

    useEffect(() => {
        if (editor !== undefined && editor.Commands !== undefined) {
            if (escapeClicked === true) {
                if (editor.Commands.isActive('core:preview') === true) {
                    editor.Commands.stop('core:preview');
                }
                if (editor.Commands.isActive('open-href-pop-up') === true) {
                    editor.Commands.stop('open-href-pop-up');
                }
                editor.Modal.close();
                setEscapeClicked(false);
            }
        }
    },[escapeClicked]);

    useEffect(() => {
        if (selectedPage > -1 && selectedProject > -1 && editor.BlockManager !== undefined) {
        editor.on('run:core:preview', () => {
            if (editor.Commands.isActive('core:fullscreen') === false) {
            editor.Commands.run('core:fullscreen');
            }
        });
        editor.on('stop:core:preview', () => {
            if (editor.Commands.isActive('core:fullscreen') === true) {
            editor.Commands.stop('core:fullscreen');
            }
        });
        }
    },[selectedPage, selectedProject]);

    return(
        <>  
            <div
            className="panel__basic-actions"
            style={selectedPage < 0 ? { display: 'none' } : null}
            />
            <ApplyStylingOptions
                anchorEl={anchorApplyStylingEl}
                setAnchorEl={setAnchorApplyStylingEl}
                projectNamesPages={projectNamesPages}
                selectedProject={selectedProject}
                selectedPage={selectedPage}
                editor={editor}
                savedPagesPerProject={savedPagesPerProject}
                setSavedPagesPerProject={setSavedPagesPerProject}
            />
        </>
    )

}



export default PanelBasicActions;